<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Insurance',
  mounted() {
    let script = document.createElement('script');
    script.src = 'https://b2c.pampadu.ru/ppdw.js';
    this.$refs.script.appendChild(script);

    let iframe = document.createElement('iframe');
    iframe.src = 'https://b2c.pampadu.ru/index.html#2bacdcc8-5675-444f-89ab-e086bd3f2ea0';
    iframe.style = 'width: 100%; border: none; height: 650px; min-width: 320px; overflow: hidden;';
    iframe.id = 'ppdwi';
    iframe.scrolling = 'no';
    this.$refs.script.appendChild(iframe);
  },
  computed: {
    ...mapGetters({
      allShowedOverlays: 'Popups/allShowedOverlays',
    }),

    isShowedPopup() {
      return this.allShowedOverlays?.includes('insurance');
    },
  },

  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
    }),
    
    closePopup() {
      this.togglePopup('insurance');
    },
  },
};
</script>

<template>
  <div
    class="popup-new"
    :class="{ 'opacity-100 visible': isShowedPopup }"
    @click.self="closePopup"
  >
    <div class="popup-new-inner">
      <div class="w-full">
        <div class="flex items-center justify-between mb-2.5 md:mb-5">
          <img src="/public/images/logo.svg" alt="" class="w-full max-w-[186px] h-[41px] pr-2">
          <div
            class="popup-new__close"
            @click="closePopup"
          ></div>
        </div>
        <div
          ref="script"
          class="mb-8"
        ></div>
      </div>
    </div>
  </div>
</template>